<h1 mat-dialog-title>
  Modelos para inclusão de regra simples
  <button mat-icon-button [mat-dialog-close]="false" class="dialog-close">
    <i class="fas fa-times" aria-hidden="true"></i>
  </button>
</h1>
<div mat-dialog-content>
  <mat-progress-bar mode="indeterminate" *ngIf="loading$ | async"></mat-progress-bar>
  <div class="row">
    <div class="col-11">
      <app-funcao-selecao></app-funcao-selecao>
    </div>
    <div class="col-1 mt-4">
      <button
        #adicionarFuncaoSelecionadaButton
        mat-mini-fab
        color="primary"
        type="button"
        title="Adicionar"
        [disabled]="(funcaoSelecionada$ | async) === null"
        (click)="adicionarFuncaoSelecionada()">
        <i class="fas fa-plus-circle" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-funcao-table
        [funcoes$]="funcoesAdicionadas$"
        (funcaoRemovida)="removerFuncaoAdicionada($event)">
      </app-funcao-table>
    </div>
  </div>
</div>
<div class="mt-4">
  <button
    mat-raised-button
    color="primary"
    class="float-right"
    [disabled]="(funcoesAdicionadas$ | async).length === 0"
    cdkFocusInitial
    (click)="baixarModelosFuncoesAdicionadas()"
  >Baixar</button>
</div>
